module.exports = __webpack_public_path__ + "img/ZAR10023.e2b9f641.png";